import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import React, { useState } from "react";
import Coverall from "../Coverall";
import Icon from "../Icon";

export interface TooltipProps {
	ariaLabel: string;
	children: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal;
	className?: string;
	icon?: string;
	interactive?: boolean;
	leaveDelay?: number;
	onClose?: (evt: React.ChangeEvent<{}>) => void; //eslint-disable-line @typescript-eslint/ban-types
	onCoverallClick?: (evt: React.ChangeEvent<{}>) => void; //eslint-disable-line @typescript-eslint/ban-types
	onOpen?: (evt: React.ChangeEvent<{}>) => void; //eslint-disable-line @typescript-eslint/ban-types
	open?: boolean;
	placement?:
		| "top"
		| "bottom-end"
		| "bottom-start"
		| "bottom"
		| "left-end"
		| "left-start"
		| "left"
		| "right-end"
		| "right-start"
		| "right"
		| "top-end"
		| "top-start"
		| undefined;
}

const LocalTooltip: React.FC<TooltipProps> = ({
	ariaLabel,
	children,
	className = "tooltip-button",
	icon = "info",
	interactive = true,
	leaveDelay = 0,
	placement = "top",
	onClose,
	onCoverallClick,
	onOpen,
	open,
	...props
}) => {
	const [showTooltip, setShowTooltip] = useState(false);
	//eslint-disable-next-line @typescript-eslint/ban-types
	const openAction = (evt: React.ChangeEvent<{}>) => {
		setShowTooltip(true);
		if (onOpen) {
			onOpen(evt);
		}
	};
	//eslint-disable-next-line @typescript-eslint/ban-types
	const closeAction = (evt: React.ChangeEvent<{}>) => {
		setShowTooltip(false);
		if (onClose) {
			onClose(evt);
		}
	};
	return (
		<>
			<Coverall show={showTooltip || open} onClick={onCoverallClick} />
			<Tooltip
				className={className}
				interactive={interactive}
				leaveDelay={leaveDelay}
				onClose={closeAction}
				onOpen={openAction}
				placement={placement}
				title={children}
				open={open}
				{...props}
			>
				<IconButton aria-label={ariaLabel} className="btn btn-info btn-tooltip">
					<Icon icon={icon} classes="fa-fw" type="solid" />
				</IconButton>
			</Tooltip>
		</>
	);
};

export default LocalTooltip;
